<template>
  <section v-if="payment || error" class="advance-summary">
    <h4>Авансирование при закрытии рейса</h4>
    <p v-if="error" class="error" role="alert">{{ error }}</p>
    <template v-if="payment">
      <p v-if="payment.status === 'PENDING_CLOSE'" class="pending">Закрытие не подтверждено. Бюджет удерживается до проверки результата.</p>
      <button v-if="payment.status === 'PENDING_CLOSE'" :disabled="busy" @click="resolve">Проверить и завершить закрытие</button>
      <AdvanceJournal :groups="[payment]" :can-cancel="payment.status === 'POSTED'" :busy="busy" @cancel="askCancel" />
    </template>
    <div v-if="cancelGroup" class="cancel-form">
      <label>Причина отмены<input v-model="cancelComment" :disabled="busy" /></label>
      <button :disabled="busy || !cancelComment.trim()" @click="cancel">Подтвердить отмену авансирования</button>
      <button :disabled="busy" @click="cancelGroup = null">Назад</button>
    </div>
  </section>
</template>

<script>
import { advanceGet, advancePost } from '@/backend/advanceApi';
import { advanceError } from '../advanceState.mjs';
import AdvanceJournal from './AdvanceJournal.vue';

export default {
  name: 'AdvancePaymentSummary', components: { AdvanceJournal },
  props: { tripNumber: { type: String, required: true } }, emits: ['resolved'],
  data: () => ({ payment: null, error: '', busy: false, cancelGroup: null, cancelComment: '', cancelId: null }),
  watch: { tripNumber: 'load' },
  mounted() { this.load(); window.addEventListener('advance-updated', this.load); },
  beforeUnmount() { window.removeEventListener('advance-updated', this.load); },
  methods: {
    async load() {
      if (this.busy) return;
      try { this.payment = (await advanceGet('/trips/' + encodeURIComponent(this.tripNumber))).payment; this.error = ''; }
      catch (error) { this.error = advanceError(error); }
    },
    askCancel(group) { this.cancelGroup = group; this.cancelComment = ''; this.cancelId = crypto.randomUUID(); },
    async cancel() {
      this.busy = true; this.error = '';
      try {
        await advancePost(`/groups/${this.cancelGroup.correlation_id}/cancel`, { comment: this.cancelComment });
        this.cancelGroup = null;
      } catch (error) { this.error = advanceError(error); }
      finally { this.busy = false; }
      window.dispatchEvent(new Event('advance-updated'));
    },
    async resolve() {
      this.busy = true; this.error = '';
      try {
        const result = await advancePost(`/groups/${this.payment.correlation_id}/resolve-close`, {});
        if (result.success) this.$emit('resolved', result);
        else this.error = result.message;
      } catch (error) { this.error = advanceError(error); }
      finally { this.busy = false; }
      window.dispatchEvent(new Event('advance-updated'));
    },
  },
};
</script>

<style scoped>
.advance-summary { margin: 12px 0; padding: 12px; border: 1px solid #bfdbfe; border-radius: 8px; background: #f8fbff; }
h4 { margin: 0 0 8px; }.error { color: #b42318; }.pending { color: #92400e; }
input, button { padding: 7px; border: 1px solid #cbd5e1; border-radius: 6px; background: white; }
label { display: flex; flex-direction: column; gap: 5px; margin-bottom: 10px; }
</style>
